import { styled } from 'styles/stitches.config'

export const Cover = styled('figure', {
  position: 'relative',
  width: '100%',
  height: 313,

  borderRadius: 10,
  background: '#C4C4C4',
  overflow: 'hidden',

  marginBottom: 22,
})
